/**
 * Bump when the cookie policy changes: a stored choice with an older version
 * is ignored and the banner asks again (FE-330).
 *
 * Kept free of `import.meta.env` so Cypress (webpack) can import it too.
 */
export const CONSENT_POLICY_VERSION = '2026-10-13'

export const CONSENT_COOKIE_NAME = 'xyro_consent'
